module.exports = __webpack_public_path__ + "media/packs/images/panes/watchers-0568c6828a7c730d1267000f42ba956d.svg";